export const GET_ALL_MAIN_BANNER_REQUEST = "GET_ALL_MAIN_BANNER_REQUEST";
export const GET_ALL_MAIN_BANNER_FAILURE = "GET_ALL_MAIN_BANNER_FAILURE";
export const GET_ALL_MAIN_BANNER_SUCCESS = "GET_ALL_MAIN_BANNER_SUCCESS";

export const GET_ALL_SIDE_BANNER_REQUEST = "GET_ALL_SIDE_BANNER_REQUEST";
export const GET_ALL_SIDE_BANNER_FAILURE = "GET_ALL_SIDE_BANNER_FAILURE";
export const GET_ALL_SIDE_BANNER_SUCCESS = "GET_ALL_SIDE_BANNER_SUCCESS";

